import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AdminComponent } from '../admin.component';
import { AdminService } from '../services/admin.service';
import { DatePipe } from '@angular/common';
import { Dealer } from '../../shared/models/dealer.interface';
import { AccountService } from '../../account/services/account.service';
import { finalize } from 'rxjs';
import { Time } from 'angular-calendar-scheduler';
import { WorkOrderDefaultTimes } from '../../account/models/workOrderDefaultTimes.interface';
import { DateService } from '../../shared/services/date.service';

@Component({
  selector: 'app-project-management',
  templateUrl: './project.management.component.html',
  styleUrls: ['./project.management.component.scss']
})
export class ProjectManagementComponent extends AdminComponent implements OnInit {
  pageTitle: string = "Admin";
  showTemplate: boolean = false;
  quoteTemplateId: number = null;
  workOrderDefaultTimes: WorkOrderDefaultTimes = { defaultStartTime: '08:00 AM', defaultStopTime: "05:00:PM" }
  times: string[];
  dealer: Dealer;
  isRequesting: boolean = false;
  errors: string;
  timeAlert: string;

  constructor(adminService: AdminService, private datepipe: DatePipe, private dateService: DateService,
    private accountService: AccountService) {
    super(adminService);

    this.times = new Array();
    for (let hour = 6; hour < 22; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        let timeValue = new Date(1970, 0, 1, hour, minute, 0);
        this.times.push(this.datepipe.transform(timeValue, 'hh:mm a'));
      }
    }
    this.times.push('10:00 PM');
  }

  ngOnInit(): void {
    this.showTemplate = false;
    super.ngOnInit();
    this.accountService.getDealer()
      .subscribe({
        next: (data: Dealer) => {
          this.dealer = data;
          this.quoteOnly = data.dealer_QuoteOnly;
          this.setDefaultWorkOrderDates();
        },
        error: (error: string) => this.onError(error)
      });
  }

  setDefaultWorkOrderDates() {
    this.workOrderDefaultTimes.defaultStartTime = this.dealer.defaultWorkOrderStartTime;
    this.workOrderDefaultTimes.defaultStopTime = this.dealer.defaultWorkOrderStopTime;
  }

  updatetDefaultWorkOrderDates() {
    this.isRequesting = true;
    this.errors = '';

    let startTime = this.workOrderDefaultTimes.defaultStartTime;
    let stopTime = this.workOrderDefaultTimes.defaultStopTime;

    this.timeAlert = this.dateService.validateTimes(startTime, stopTime);


    if (this.timeAlert === null) {
    this.accountService.saveDefaultWorkOrderTimes(this.workOrderDefaultTimes)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {
          next: (result) => {
            if (result) {
            }
          },
          error: (error: string) => this.errors = error
        });
    }
    else {
      this.isRequesting = false;
    }
  }

  displayTemplateEdit(event): void {
    this.quoteTemplateId = event;
    this.showTemplate = true;
  }

  displayItemNoteTemplateEdit(event): void {
   
  }

  toggleTemplateDisplay(event): void {
    this.showTemplate = event != null ? false : true;
  }

  onError(response: string) {
    window.alert($localize`Sorry, something went wrong.  Please contact Bidit Support.` + 'r\n' + response);
    console.log(response);
  }

}
